import { VehicleCatalogNodeKind, type VehicleCatalogNodeListApiResponse } from '@navio/nsdk';
import { URLKeys } from 'noddi-async';
import { type FilterOptionSource } from 'noddi-ui-web';
import { useDebounceValue } from 'noddi-util';
import { useState } from 'react';
import { vehicleCatalogNodeOptionLabel } from '../../../features/VehicleCatalog/vehicleCatalogNodeOptions';
import { toFilterOptionSource, useFilterOptionsGet } from '../useFilterOptionsGet';

/** Title, description and visible options of this filter, for the builder next to its options. */
export const VEHICLE_CATALOG_NODE_FILTER_TEXT = {
  title: 'OEM vehicle',
  description: 'Vehicle make or model linked to the original equipment mark'
};

const OEM_KINDS = [VehicleCatalogNodeKind.MAKE, VehicleCatalogNodeKind.MODEL];

/** Catalog nodes of the given kinds as filter options (first 100), searchable. For `unit.multiSelect`. */
export const useVehicleCatalogNodeOptions = ({
  kinds = OEM_KINDS,
  parentIds
}: { kinds?: VehicleCatalogNodeKind[]; parentIds?: number[] } = {}): FilterOptionSource<number> => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounceValue({ value: search, delay: 300 });

  const query = useFilterOptionsGet({
    type: URLKeys.getVehicleCatalogNodes,
    input: { pageIndex: 0, pageSize: 100, search: debouncedSearch, kinds, parentIds },
    queryConfig: { select: toNodeOptions }
  });

  return toFilterOptionSource(query, 'number', { search, onSearch: setSearch });
};

const toNodeOptions = ({ results }: VehicleCatalogNodeListApiResponse) =>
  results.map((node) => ({ value: node.id, label: vehicleCatalogNodeOptionLabel(node) }));
